import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";

export interface IFieldtype {
  type: "number" | "string" | "boolean";
  onChange: (value: any) => void;
  value: any;
  disabled?: boolean;
}

export const FieldType = ({ type, onChange, value, disabled }: IFieldtype) => {
  return (
    <>
      {type === "number" && (
        <InputNumber
          mode={"decimal"}
          maxFractionDigits={20}
          value={value}
          disabled={disabled}
          onValueChange={(e) => onChange(e.value)}
        />
      )}
      {type === "string" && (
        <InputText value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)} />
      )}
      {type === "boolean" && (
        <InputSwitch checked={value} disabled={disabled} onChange={(e) => onChange(e.value)} />
      )}
    </>
  );
};
